"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetListing = void 0;
const Base_1 = require("./Base");
exports.GetListing = {
    url: Base_1.URL_BASE + "/list",
    method: "GET",
    secure: false
};
//# sourceMappingURL=GetListing.js.map